<template>
  <section>
    <div class="usercontainer clearfix">

      <Pingjia v-for="(item) in commentList" :key="item.id" :commentItem="item"></Pingjia>
    </div>
  </section>
</template>

<script>
import Pingjia from "../components/pingjia";
export default {
  components:{Pingjia},
  name: "Pinjia",
  data() {
    return {
  
      commentList: [],
    };
  },
  props: {},
  methods: {
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      // console.log(this.dialogImageUrl)
    },
    filechange(file, fileList){
      console.log(file, fileList)
    },
    exceed(files, fileList) {
      this.$message.error(`最多只能上传${this.limit}张图片！`);
    },
    // 封装获取数据的方法
    async getOrderDetail() {
      console.log(this.orderno);
      let data = getParameterByName();
      let url = data.jifen ? "member/ordergiftlist" : "Member/orderdetail";
      let res = await this.$fetch(url, {
        body: {
          orderno: data.orderno
        }
      });
      // console.log(res);
      // res.shipfee = parseFloat(res.shipfee);
      // res.amount = parseFloat(res.amount);
      let arr=res.detail.filter((item)=>item.iscomment==0);
      console.log(arr[0])
      this.commentList=arr;
      // this.orderDetail = res;
    }
  },
  mounted() {
    this.getOrderDetail();
  }
};
</script>

<style lang='scss' scoped>
.user-cont{
  align-items: flex-start;
}
.container {
  background: #fff;
  padding-top: 20px;
}
.row {
  margin: 20px 0;
}
.pinjiatype {
  margin-bottom: 10px;
}
.cont {
  .el-rate__item {
    i {
      font-size: 30px;
    }
  }
}
.num_text {
  display: flex;
  width: 300px;
  flex-direction: column;
  justify-content: space-around;
  .row{
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/add_pinjia.vue